var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6L8 4L13.5 6L11 7.5V9C11 9 10.333 8.5 8 8.5C5.667 8.5 5 9 5 9V7.5L2.5 6ZM2.5 6V10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5V9.389C11 11.107 9.657 12.5 8 12.5C6.343 12.5 5 11.107 5 9.389V8.5M15.318 11.03C15.318 11.03 15.803 10.677 17.5 10.677C19.197 10.677 19.682 11.029 19.682 11.029M15.318 11.03V10L13.5 9L17.5 7.5L21.5 9L19.682 10V11.029M15.318 11.03V11.318C15.318 11.8967 15.5479 12.4517 15.9571 12.8609C16.3663 13.2701 16.9213 13.5 17.5 13.5C18.0787 13.5 18.6337 13.2701 19.0429 12.8609C19.4521 12.4517 19.682 11.8967 19.682 11.318V11.029M16 20H19.705C20.478 20 21.092 19.624 21.644 19.098C22.774 18.022 20.919 17.162 20.212 16.741C19.5832 16.3699 18.8851 16.1316 18.1606 16.041C17.4362 15.9504 16.7008 16.0092 16 16.214M4.385 15.926C3.442 16.453 0.968999 17.528 2.475 18.873C3.211 19.53 4.03 20 5.061 20H10.939C11.969 20 12.789 19.53 13.525 18.873C15.031 17.528 12.558 16.453 11.615 15.926C9.403 14.691 6.597 14.691 4.385 15.926Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/Student.0f7b488e42adc2f24755134e41a1c6c0.svg";
export { ForwardRef as ReactComponent };